import { render, staticRenderFns } from "./ModalDetallesMontos.vue?vue&type=template&id=0e727a46"
import script from "./ModalDetallesMontos.vue?vue&type=script&lang=js"
export * from "./ModalDetallesMontos.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports